import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import { getEvent, storeEventData } from 'store/slices';

import EventProcessSideSection from '../EventProcessSideSection';
import ImportantDatesForm from 'components/ReusableForms/ImportantDates';
import CommitteeMemberFrom from 'components/ReusableForms/CommitteeMember';
import SpeakerForm from 'components/ReusableForms/Speaker';
import PastConferencesGallery from 'components/ReusableForms/PastConferencesGallery';
import AgendaForm from '../../EventDetails/Agenda/AgendaForm';
import InstantPass from 'components/ReusableForms/InstantPass';

const InstantPost = ({ isViewMode }) => {
  const dispatch = useDispatch();
  const { eventId } = useParams();

  const [activeTab, setActiveTab] = useState('important_dates');
  const [completedTabs, setCompletedTabs] = useState([]);
  const [isFormLoading, setIsFormLoading] = useState(true);

  const tabOrder = [
    'important_dates',
    'committee_member',
    'speaker',
    'past_conferences_gallery',
    'agenda',
    'instant_pass',
  ];

  // Fetch event details
  const fetchEventDetails = async () => {
    try {
      setIsFormLoading(true);
      await dispatch(getEvent(eventId));
    } finally {
      setIsFormLoading(false);
    }
  };

  // Fetch data on mount and cleanup on unmount
  useEffect(() => {
    fetchEventDetails();

    return () => {
      dispatch(storeEventData({}));
    };
  }, [eventId]);

  // Handle moving to the next tab
  const handleNext = (currentKey) => {
    const currentIndex = tabOrder.indexOf(currentKey);
    const nextTab = tabOrder[currentIndex + 1];

    if (nextTab) {
      setCompletedTabs((prev) => [...new Set([...prev, currentKey])]); // Avoid duplicates
      setActiveTab(nextTab);
    }
  };

  return (
    <Card>
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => {
          setActiveTab(k);
        }}
        className="custom-tabs mb-2 gap-4 cpt-15 cps-15"
      >
        <Tab eventKey="important_dates" title="Important Dates" disabled={isFormLoading} />
        <Tab eventKey="committee_member" title="Committee Member" disabled={isFormLoading} />
        <Tab eventKey="speaker" title="Speaker" disabled={isFormLoading} />
        <Tab eventKey="past_conferences_gallery" title="Past Gallery" disabled={isFormLoading} />
        <Tab eventKey="agenda" title="Agenda" disabled={isFormLoading} />
        <Tab eventKey="instant_pass" title="Instant Pass" disabled={isFormLoading} />
      </Tabs>
      {isFormLoading ? (
        <div className="text-center py-5">
          <Loader size="lg" />
        </div>
      ) : (
        <div className="row">
          <div className="col-md-9">
            {activeTab === 'important_dates' && (
              <div className="cmt-20 cms-20">
                <ImportantDatesForm
                  eventId={eventId}
                  fetchEventDetails={fetchEventDetails}
                  eventTab
                  handleNext={handleNext}
                />
              </div>
            )}
            {activeTab === 'committee_member' && (
              <div className="cmt-20 cms-20">
                <CommitteeMemberFrom
                  eventId={eventId}
                  fetchEventDetails={fetchEventDetails}
                  eventTab
                  handleNext={handleNext}
                />
              </div>
            )}
            {activeTab === 'speaker' && (
              <div className="cmt-20 cms-20">
                <SpeakerForm
                  eventId={eventId}
                  fetchEventDetails={fetchEventDetails}
                  eventTab
                  handleNext={handleNext}
                />
              </div>
            )}

            {activeTab === 'past_conferences_gallery' && (
              <div className="cmt-20 cms-20">
                <PastConferencesGallery
                  eventId={eventId}
                  fetchEventDetails={fetchEventDetails}
                  eventTab
                  handleNext={handleNext}
                />
              </div>
            )}

            {activeTab === 'agenda' && (
              <AgendaForm
                eventId={eventId}
                fetchEventDetails={fetchEventDetails}
                eventTab
                handleNext={handleNext}
              />
            )}

            {activeTab === 'instant_pass' && (
              <div className="cmt-20 cms-20">
                <InstantPass
                  eventId={eventId}
                  fetchEventDetails={fetchEventDetails}
                  eventTab
                  handleNext={handleNext}
                />
              </div>
            )}
          </div>

          {/* Right side: Sidebar/Status */}
          <div
            className="col-md-3 cps-20"
            style={{ borderLeft: '1px solid #ccc' }}
          >
            <EventProcessSideSection
              tabOrder={tabOrder}
              completedTabs={completedTabs}
              isViewMode={isViewMode}
              type={activeTab}
            />
          </div>
        </div>)}
    </Card>
  );
};

export default InstantPost;
